import React, { useCallback, useRef, useState } from 'react';
import Draggable from "react-draggable";

import { useResizeObserver } from "../hooks/useResizeObserver";

const CustomDraggable = (props) => {
  const { children, baseX, baseY, parent, bounce, borderOffset, onStop, ...other } = props;
  const [ position, setPosition ] = useState(null);
  const parentRef = useRef(parent);

  const _baseX = baseX !== undefined ? baseX : 0;
  const _baseY = baseY !== undefined ? baseY : 0;
  const rect = parent.getBoundingClientRect();
  const [ parentSize, setParentSize ] = useState({
    width: rect.width,
    height: rect.height,
  });

  useResizeObserver(parentRef, (entry) => {
    const rect = entry.contentRect;
    setParentSize({
      width: rect.width,
      height: rect.height,
    });
  });

  const adjustPosition = useCallback((data) => {
    const topLimit = 0;
    const leftLimit = 0;
    const rightLimit = parentSize.width;
    const bottomLimit = parentSize.height;
    //境界値の補正
    const _borderOffset = {
      top: 0,
      left: 0,
      right: -10,
      bottom: -10,
      ...borderOffset,
    };
    //端から何ピクセル戻すか
    const _bounce = {
      top: 0,
      left: 30,
      right: 30,
      bottom: 30,
      ...bounce,
    };
    let {x, y} = data;
    x += _baseX;
    y += _baseY;
    if (data.node.clientWidth > 0) {
      if (x + data.node.clientWidth - _bounce.left < leftLimit + _borderOffset.left) {
        x = leftLimit - (data.node.clientWidth - _bounce.left);
      }
    } else if (x < leftLimit + _borderOffset.left) {
      x = leftLimit;
    }
    if (y < topLimit + _borderOffset.top) {
      y = topLimit - _bounce.top;
    }
    if (x > rightLimit + _borderOffset.right) {
      x = rightLimit - _bounce.right;
    }
    if (y > bottomLimit + _borderOffset.bottom) {
      y = bottomLimit - _bounce.bottom;
    }
    x -= _baseX;
    y -= _baseY;
    setPosition({x, y});

    return {x, y};
  }, [_baseX, _baseY, parentSize, borderOffset, bounce]);

  const handleStop = useCallback((event, data) => {
    const {x, y} = adjustPosition(data);

    if (onStop) {
      data.x = x;
      data.y = y;
      onStop(event, data);
    }
  }, [adjustPosition, onStop]);

  return (
    <Draggable position={position} onStop={handleStop} {...other}>
      {children}
    </Draggable>
  );
}

export default CustomDraggable;
